export default "__VITE_ASSET__13fe241f__"